import { render } from "./HomeButton.vue?vue&type=template&id=1b99a604&scoped=true"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"

import "./HomeButton.vue?vue&type=style&index=0&id=1b99a604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b99a604"]])

export default __exports__